import ChalkySticks from '@chalkysticks/sdk';

/**
 * @type interface
 */
export interface IStoreState {
	hasBeenLandscape: boolean;
	isLandscape: boolean;
	languageCode: string;
	lastOpened: number;
	matchConfig: Trainer.IMatchConfig | null;
	navigatingUserModel: ChalkySticks.Model.User | undefined;
	navigatingVenueModel: ChalkySticks.Model.Venue | undefined;
	queryParameters: IQueryParameters;
	showPrimaryContextMenu: boolean;
	showingKeyboard: boolean;
	venueCollection: ChalkySticks.Collection.Venue | undefined;
}

/**
 * @class State
 * @package Store
 * @project ChalkySticks App
 */
const state: IStoreState = {
	hasBeenLandscape: false,
	isLandscape: false,
	languageCode: 'en-US',
	lastOpened: 0,
	matchConfig: null,
	navigatingUserModel: undefined,
	navigatingVenueModel: undefined,
	queryParameters: {},
	showPrimaryContextMenu: false,
	showingKeyboard: false,
	venueCollection: undefined,
};

export default state;
